import React from 'react';
import QuestionHeader from '../shared/questionHeader/QuestionHeader';
import QuestionAnswers from './components/questionAnswers/QuestionAnswers';
import styles from './imageQuestion.css';

/**
 *
 * @type {React.NamedExoticComponent<{readonly statisticsPopup?: *, readonly setEventSound?: *, readonly handleAnswerSelection?: *, readonly contentColor?: *, readonly question?: *, readonly statistics?: *}>}
 */
const ImageQuestion = React.memo( ( { question, handleAnswerSelection, statistics, statisticsPopup, contentColor, setEventSound } ) => {

    const isHaveAnswers = ( question.localization !== null && typeof question.localization !== 'undefined' ) ? true : false;
    return (
        isHaveAnswers &&
        <div className={ styles.wrapper } style={ statisticsPopup ? { pointerEvents: 'none' } : { filter: 'none' } }>
            <QuestionHeader
                question={ question }
                statistics={ statistics }
                statisticsPopup={ statisticsPopup }
                contentColor={ contentColor }
                setEventSound={ setEventSound }
            />
            <QuestionAnswers
                setEventSound={ setEventSound }
                question={ question }
                answers={ question.localization !== null && question.localization.editor_mode_answers }
                handleAnswerSelection={ handleAnswerSelection }
            />
        </div>
    );
} );


export default ImageQuestion;
